import se from './intl/se';
import fi from './intl/fi';
import no from './intl/no';
import fisv from './intl/fi-sv';

const locales = {
  se,
  fi,
  no,
  fisv,
};

const removeLeadingZero = (str: string): any => {
  const f = str.substr(0, 1);
  if (f !== '0') return str;
  return removeLeadingZero(str.substr(1, str.length));
};

export const formatSkuNumber = (sku: string) => {
  // http://cdn.clasohlson.com/productimages/1200x1200/38-8042-2_1.jpg
  // 344566010
  const p1 = sku.substr(0, 2); // 2 tecken
  const p2 = removeLeadingZero(sku.substr(2, 4)); // 4 tecken,inledande 0or tas bort
  const p3 = removeLeadingZero(sku.substr(6, 3)); // 3 tecken, bara 0or tas bort helt, annars inledande 0or

  let f = `${p1}-${p2}`;
  if (p3.length > 0) f = `${f}-${p3}`;
  return f;
};

export function getParameterByName(name: string, url?: string): string | undefined {
  if (!url) url = window.location.href;
  let _name = name;
  _name = name.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp('[?&]' + _name + '(=([^&#]*)|&|#|$)');
  const results = regex.exec(url);
  if (!results) return undefined;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function getCountryCodeFromUrl() {
  let countryCode = 'se';
  const paths = window.location.pathname.split('/');
  paths.shift();

  if (paths[0]) {
    countryCode = paths[0];
  }

  return countryCode;
}

export const getLanguage = () => {
  let langCode = getCountryCodeFromUrl();

  const urlParams = new URLSearchParams(window.location.search);
  const isoLang = urlParams.get('isoCode');

  if (isoLang) {
    langCode = isoLang == 'sv' ? `${langCode}${isoLang}` : isoLang;

    // langCode = `${langCode}${isoLang}`;
    // console.log('A langcode', langCode);
    // console.log('langCode', langCode);
  }
  return langCode;
};

const localeMap = {
  se: 'sv-SE',
  en: 'en-GB',
  fi: 'fi-FI',
  no: 'nb-NO',
};

// Format prices to correspond with price on clasohlson.se
export function formatPrice(price: number, countryCode: string) {
  const localeStr = localeMap[countryCode];
  return price.toLocaleString(localeStr, {
    currency: 'SEK',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  // return price
  //   .toFixed(2)
  //   .toString()
  //   .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ' ')
  //   .replace('.', ',');
}

export const useTranslation = () => {
  const lang = getLanguage();
  const locale = locales[lang];
  const t = (key: string) => {
    return locale[key] ? locale[key] : key;
  };
  return { t };
};

export const formatDate = (date: Date) => {
  const d = new Date(date);
  const locale = getLanguage();
  const separator = locale === 'se' ? '-' : '.';
  const fullYear = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const order = locale === 'se' ? [fullYear, month, day] : [day, month, fullYear];

  return order.join(separator);
};
